import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
const PHONE = '5491162837699';
const MESSAGE = encodeURIComponent('Hola! Tengo una consulta sobre SUPERKIT IA.');
export const FloatingWhatsApp = () => {
  const href = `https://wa.me/${PHONE}?text=${MESSAGE}`;
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp" initial={{
    opacity: 0,
    scale: 0.6,
    y: 20
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    delay: 1.2,
    type: 'spring',
    stiffness: 260,
    damping: 18
  }} className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-50 group" data-id="element-35">
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping pointer-events-none" data-id="element-36"></span>

      <div className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-full shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] pl-3 pr-4 py-3 md:pl-4 md:pr-5 md:py-3.5 transition-colors" data-id="element-37">
        <svg viewBox="0 0 32 32" className="w-6 h-6 md:w-7 md:h-7 fill-current" aria-hidden="true" data-id="element-38">
          <path d="M19.11 17.39c-.28-.14-1.65-.81-1.9-.9-.26-.1-.44-.14-.63.14-.18.28-.72.9-.88 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.43-2.24-1.39-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.63-1.52-.86-2.08-.23-.55-.46-.47-.63-.48l-.54-.01c-.18 0-.49.07-.74.35-.26.28-.97.95-.97 2.31 0 1.36.99 2.68 1.13 2.86.14.18 1.95 2.98 4.73 4.18.66.28 1.18.45 1.58.58.66.21 1.27.18 1.74.11.53-.08 1.65-.67 1.88-1.32.23-.65.23-1.2.16-1.32-.07-.12-.26-.18-.54-.32zM16.03 4C9.93 4 5 8.93 5 15.03c0 1.94.51 3.83 1.48 5.5L5 27l6.65-1.45a11 11 0 0 0 4.38.96h.01c6.1 0 11.03-4.93 11.03-11.03S22.13 4 16.03 4zm0 20.16h-.01a9.13 9.13 0 0 1-4.66-1.28l-.33-.2-3.95.86.85-3.85-.22-.34a9.07 9.07 0 0 1-1.39-4.83c0-5.04 4.1-9.14 9.14-9.14 2.44 0 4.74.95 6.47 2.68a9.08 9.08 0 0 1 2.68 6.46c0 5.04-4.1 9.14-9.14 9.14z" data-id="element-39" />
        </svg>
        <span className="font-bold text-sm md:text-base hidden sm:inline" data-id="element-40">
          ¿Dudas? Hablanos
        </span>
        <span className="font-bold text-sm sm:hidden" data-id="element-41">WhatsApp</span>
      </div>
    </motion.a>;
};